import { useCallback } from "react";
import { useParams } from "react-router-dom";

import { DatabaseBackup, X } from "lucide-react";
import { AlertTitle, AlertWrapper, Button } from "twyne-new.ui";

import { formatDate } from "utils";

export default function DefaultChangeHistoryHeader({ entityCollection, loading }) {
  const { id: entityId } = useParams()
  const { item, setItem, save, fetchById, history: { preview, setPreview } } = entityCollection

  const { createdAt, user, meta } = preview || {}
  const { first_name: firstName, last_name: lastName } = user || {}
  const { versionName } = meta || {}

  const handleClose = useCallback(async () => {
    setPreview(null)
    setItem(null)
    await fetchById(entityId)
  }, [entityId, fetchById, setPreview, setItem])

  const handleRestore = useCallback(async () => {
    if (!preview) return;
    await save(item)
    handleClose()
  }, [item, preview, save, handleClose])

  if (!preview) {
    return null;
  }

  return <>
    <AlertWrapper variant="warning" className="m-0 py-1 px-2 flex items-center">
      <AlertTitle className="p-0 m-0">
        <div className="flex flex-col gap-1 justify-center items-end">
          <div className="text-sm">
            {versionName || formatDate(createdAt, "MMM DD, YYYY - hh:mm A")}
          </div>
          <div className="text-sm font-normal italic">
            {firstName || lastName ? `${firstName} ${lastName}`.trim() : "--"}
          </div>
        </div>
      </AlertTitle>
    </AlertWrapper>
    <Button color="warning" className="items-center" onClick={handleRestore} disabled={loading}>
      <DatabaseBackup size={16} />
      Restore
    </Button>
    <Button color="warning" variant="outline" className="items-center" onClick={handleClose} disabled={loading}>
      <X size={16} />
      Close
    </Button>
  </>
}
